// Statuts de commande fournisseur — source unique côté front.
// Codes canoniques IDENTIQUES au backend (backend/constants/order_status.py) et à la base.

export const ORDER_STATUS = {
  EN_ATTENTE_ENVOI: 'en_attente_envoi',
  ENVOYE: 'envoye',
  EN_ATTENTE_COMPLEMENT: 'en_attente_complement',
  LIVRE: 'livre',
  ANNULE: 'annule',
};

// Métadonnées d'affichage : couleur MUI (colorKey) + clé i18n du libellé.
// Les libellés eux-mêmes restent dans les fichiers de traduction (aucun texte en dur ici).
export const ORDER_STATUS_META = {
  [ORDER_STATUS.EN_ATTENTE_ENVOI]:      { colorKey: 'warning', i18nKey: 'orders.pendingSend' },
  [ORDER_STATUS.ENVOYE]:                { colorKey: 'info',    i18nKey: 'orders.sent' },
  [ORDER_STATUS.EN_ATTENTE_COMPLEMENT]: { colorKey: 'info',    i18nKey: 'orders.pendingComplement' },
  [ORDER_STATUS.LIVRE]:                 { colorKey: 'success', i18nKey: 'orders.delivered' },
  [ORDER_STATUS.ANNULE]:                { colorKey: 'error',   i18nKey: 'orders.cancelled' },
};

// Ensembles métier (mêmes que le backend : CANCELLABLE / RECEIVABLE)
const CANCELLABLE = [ORDER_STATUS.EN_ATTENTE_ENVOI, ORDER_STATUS.ENVOYE];
const RECEIVABLE  = [ORDER_STATUS.ENVOYE, ORDER_STATUS.EN_ATTENTE_COMPLEMENT];

export const isCancellable = (status) => CANCELLABLE.includes(status);
export const canReceive    = (status) => RECEIVABLE.includes(status);

// Éditable : une commande n'est modifiable qu'en attente d'envoi (figée une fois envoyée)
export const isEditable    = (status) => status === ORDER_STATUS.EN_ATTENTE_ENVOI;
